export default "__VITE_ASSET__d5d84c60__"